export default __webpack_public_path__ + "static/media/icon-file-generic.168d82d9.svg";